import { useForm } from "react-hook-form";
import TextField from "../../../ui/TextField";
import RangeField from "../../../ui/RangeField";
import SearchCondition from "../../../features/SearchCondition";
import Button from "../../../ui/Button";
import Summary from "../../../ui/Summary";
import styles from "../../../layout/admin/Main.module.scss";
import { validateMaxlength } from "../../../../utils/validate";

const UnitModalSearchForm = ({ setSearchCondition, setErrorMessage }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const resetCondition = () => {
    setValue("attended_period_f", "");
    setValue("attended_period_t", "");
    setErrorMessage("");
  };

  const onSubmit = (data) => {
    if (!data.attended_period_f || !data.attended_period_t) {
      setErrorMessage("講座開催日の開始日と終了日を入力してください。");
      return;
    }
    if (data.attended_period_f > data.attended_period_t) {
      setErrorMessage("開始日が終了日より後になっています。");
      return;
    }
    setErrorMessage("");
    setSearchCondition(data);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <SearchCondition title="期間を設定">
          <table>
            <tr>
              <td>
                <RangeField
                  type="date"
                  register={register}
                  errors={errors}
                  label="講座開催日"
                  nameFrom={"attended_period_f"}
                  nameTo={"attended_period_t"}
                ></RangeField>
              </td>
            </tr>
          </table>
        </SearchCondition>
        <div className={styles.buttonbox}>
          <Button type="submit" styleType="search">
            検索
          </Button>
          <Button
            type="button"
            styleType="back"
            onClick={() => resetCondition()}
          >
            条件クリア
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UnitModalSearchForm;
